module.exports = __webpack_public_path__ + "media/images/emblems/Fahy.Jura.CH-b5d806595713f429d82939291982e64c.png";